var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"small":"","color":"transparent","elevation":"2"},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_vm._v(_vm._s(_vm.value ? _vm.hideText : _vm.showText))])}
var staticRenderFns = []

export { render, staticRenderFns }